import Backbone from 'backbone'

/**
 * Реэкспорт Backbone, чтобы работала шина событий.
 */
export default Backbone

/**
 * Возвращает глобальную шину событий для ES5/ES6 приложений.
 * @returns {Backbone} Глобальная шина событий.
 */
export function getGlobalEventBus () {
  return window.Backbone || Backbone
}
